export const FILE_REDUCER_STATE_ID = 'file';
